<template>
  <billing-customer>
    <div class="container-fluid" id="content-customer">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3"  id="s-f-r" style="padding:0px;">
          <div class="card box_custom search-box">
            <div class="countItems"><h4 class="page-title">Customer</h4></div>
            <!-- <div class="countItems"><h3> 182</h3> <span>Total customer</span></div> -->
            <div class="btn-group d-flex justify-content-end actionTop" role="group" aria-label="Button group with nested dropdown ">
              <div class="btn-group" role="group">
                <button id="btnGroupDrop1" type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-click-outside="hide" v-on:click="ShowMenuDropPCus" v-bind:class="{ show: ShowMenuDropCus }">
                  <i class="fas fa-cog"></i>
                </button>
                <button type="button"  class="btn btn-success btn-new" @click="showformregister"><i class="fas fa-plus"></i></button>
                <div class="dropdown-menu dropdown-menu-right" style="width:184px" aria-labelledby="btnGroupDrop1" v-bind:class="{ show: ShowMenuDropCus }" v-show="ShowMenuDropPCus">
                  <!-- <div class="loadermini"></div> -->
                  <div class="custom-control custom-checkbox mr-sm-2" style="margin-left: 0.4rem !important;font-size: 15px;">
                    <input type="checkbox" class="custom-control-input" id="customControlAutosizing" v-model="show_business" @change="check($event)">
                    <label class="custom-control-label" for="customControlAutosizing">Show Business Name</label>
                  </div>
                  <div class="custom-control custom-checkbox mr-sm-2" style="margin-left: 0.4rem !important;font-size: 15px;">
                    <input type="checkbox" class="custom-control-input" id="customControlAutosizing2" v-model="show_customer" @change="checkcus($event)">
                    <label class="custom-control-label" for="customControlAutosizing2">Show Inactives</label>
                  </div>
                </div>
              </div>
            </div>
            <form class="app-search position-absolute" >
              <input type="text" class="form-control" placeholder="Search Client or Business" autofocus="autofocus"  v-model="TextSearchCustomer">
              <a class="srh-btn">
                <i class="fas fa-search"></i>
              </a>
            </form>
            <div class="comment-widgets srollclientes">
              <div class="card card-body" >
                <Loader v-if="isLoadingCustomers"></Loader>                
                <div class="list-group list-group-flush">
                  <div class="list-group-item list-group-item-action d-flex justify-content-between align-items-left filteredCustomer" v-for="item in filteredCustomer" :key="item.id" @click="detailCustomer(item.id)" >
                    <div class="d-block">
                      <span>{{item.firstname}} {{item.lastname}}</span>
                      <small class="d-block" style="color:rgb(160, 160, 160);" v-if="show_business == true">{{item.bussinesname}}</small>
                    </div>
                    <span class="badge badge-default" v-bind:class="{'balance':(item.balance > 0)}">
                      <h6> $ {{item.balance | formatMoney}}</h6>
                    </span>
                  </div>
                </div>
                <div v-if="CustomersList.length == 0" class="msj-no-customer">
                  <h3 style="text-align: center; ">It's time to create your first Customer!</h3>
                  <button type="button" class="btn btn-success" @click="showformregister" style="margin-top: 7px;">Create New Customer</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-8 col-xl-9 right-contenendor">
          <div class="card">
            <div class="content-default-customer" @statusContent="EmitMethodStatus" v-if="ShowDefaultContentCustomer">
              <div class="card-body">
                <div class="card-body contenedor-total d-flex0" >
                  <div role="alert" class="c-ol alert alert-success alert_totales_customer">
                    Active Customers:
                    <h1><span class="badge badge-success">{{Totalactivos.length}}</span></h1>
                  </div>
                  <div role="alert" class="c-ol alert alert-danger alert_totales_customer">
                    Inactive Customers: 
                    <h1 ><span class="badge badge-danger">{{inactivos.length}}</span></h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-form-register" v-show="registerForm">
              <div class="card-header">
                <h5 class="card-title">{{NewCustomer.titleactionForm}} Customer</h5>
              </div>
              <div class="card-body">
                <div class="alert alert-success" role="alert" v-if="MessageSuccefull != null">
                  {{MessageSuccefull.message}}
                </div>
                <div class="bgloading" v-if="isLoading">
                  <Loader></Loader>
                </div>
                <form class="form-horizontal form-material" @submit.prevent="MetNewCustomerAdd">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="form-group d-block text-right" style="width:100%">
                          <input type="hidden" class="form-control" v-model="NewCustomer.idcustomer" name="idcustomer"> 
                          <button type="submit" onclick="document.getElementById('s-f-r').style.display='block'" class="btn btn-success btn-lg b-block BtnSave"><i class="fas fa-save"></i> Save</button> 
                          <button type="button"  class="btn btn-light btn-lg b-block Btncancel" @click="MetCancelFormC2(customerDetail[0].id)" v-if="ShowBtncancel"><i class="fas fa-window-close"></i> Cancel</button>
                          <button type="button" onclick="document.getElementById('s-f-r').style.display='block'" class="btn btn-light btn-lg b-block Btncancel" @click="MetCancelFormC" v-else><i class="fas fa-window-close"></i> Cancel</button>
                          <button type="button" @click="MetDeleteCustomer(customerDetail[0].id)" v-if="ShowBtnDel" class="btn btn-danger btn-lg b-block BtnDel"><i class="fas fa-trash-alt"></i> Delete</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xl-6">
                          <div class="form-group">
                            <label class="">First Name:</label>
                            <input type="text" name="firstname" v-model="NewCustomer.firstname" class="form-control" required>
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-6">
                          <div class="form-group">
                            <label class="">Last Name:</label>
                            <input type="text" name="lastname" v-model="NewCustomer.lastname" class="form-control">
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12">
                          <div class="form-group">
                            <label class="">Bussines Name:</label>
                            <input type="text" name="bussinesname" v-model="NewCustomer.businessname" class="form-control">
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-12 col-xl-6">
                          <div class="form-group">
                            <label class="">Active:</label>
                            <select class="form-control" id="" v-model="NewCustomer.active">
                              <option value="1">Active</option>
                              <option value="0">Inactive</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-12 col-xl-6">
                          <div class="form-group">
                            <label class="">Referal:</label>
                            <select class="form-control" name="referal" v-model="NewCustomer.referal">
                              <option value="0" selected> -- Select --</option>
                              <option value="1">Google Organic</option>
                              <option value="2">Referal from existing client</option>
                              <option value="3">Ads</option>
                              <option value="4">Signs</option>
                              <option value="5">Direct mail</option>
                              <option value="6">Other</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-6 col-xl-6">
                      <div class="row">
                        <div class="col-md-12 col-lg-12">
                          <div class="form-group">
                            <label class="">Email:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.email" name="email">
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-6">
                          <div class="form-group">
                            <label class="">Office Phone:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.officephone" name="officephone">
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-6">
                          <div class="form-group">
                            <label class="">Mobile Phone:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.mobilephone" name="mobilephone">
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="">Website:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.website" name="website">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div style="border-top: 1px solid #cecece; display:block; margin-bottom: 30px;"></div>
                  <div class="row">
                    <div class="col-md-6" >
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="">Billing Address:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.billingaddress">
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-4">
                          <div class="form-group">
                            <label class="">City:</label>
                            <input type="text" class="form-control" name="bcity" v-model="NewCustomer.bcity">
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-4">
                          <div class="form-group">
                            <label class="">State:</label>
                            <input type="text" class="form-control" name="bstate" v-model="NewCustomer.bstate">
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-4">
                          <div class="form-group">
                            <label class="">Zip code:</label>
                            <input type="text" class="form-control" name="bpostcode" v-model="NewCustomer.bpostcode">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="">Address:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.address" name="address">
                          </div>
                        </div>                          
                        <div class=" col-md-12 col-lg-12 col-xl-4">
                          <div class="form-group">
                            <label class="">City:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.acity" name="acity" >
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-4">
                          <div class="form-group">
                            <label class="">State:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.astate" name="astate">
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-4">
                          <div class="form-group">
                            <label class="">Zip Code:</label>
                            <input type="text" class="form-control" v-model="NewCustomer.apostcode" name="apostcode"> 
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="form-group d-block" style="width:100%">
                          <label class="">Notes:</label>
                          <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="NewCustomer.notes" name="notes"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="content-detail-customer" v-show="detailcontent" v-if="customerDetail !== null">
              <div class="bgloading" v-show="isLoading">
                <Loader></Loader>
              </div>
              <div class="card-header">
                <div class="row">
                  <div class="col-md-6">
                    <h3 class="card-title">{{customerDetail[0].firstname}} {{customerDetail[0].lastname}}</h3>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-12 col-md-3 text-center">
                        <button @click="MetEditCustomers" class="btn btn-info btn-sm eboton"><i class="fas fa-pen"></i> Edit</button>
                      </div>
                      <div class="col-12 col-md-5">
                        <select class="form-control" @change="getTransactions()" v-model="transactionsID">
                          <option value="0" label="All">All</option>
                          <option value="1" label="Estimates">Estimates</option>
                          <option value="2" label="Invoices">Invoices</option>
                          <option value="3" label="Recurring Invoices">Recurring Invoices</option>
                          <option value="4" label="Payments" >Payments</option>
                        </select>
                      </div>
                      <div class="col-12 col-md-4 " >
                        <span class="cdropdown">
                          <button class="btn btn-transaction">NEW</button>
                          <label>
                            <input type="checkbox">
                            <ul class="text-left">
                              <li @click="estimateNewtransac(customerDetail[0].id)">
                                <button>
                                  <i class="fas fa-file"></i> Estimate
                                </button>
                              </li>
                              <li @click="invoiceNewtransac(customerDetail[0].id)">
                                <button>
                                  <i class="fas fa-file"></i> Invoice
                                </button>
                              </li>
                              <li @click="recurringNewtransac(customerDetail[0].id)">
                                <button>
                                  <i class="fas fa-file"></i> Recurring Invoice
                                </button>
                              </li> 
                              <li @click="paymentsNewtransac(customerDetail[0].id)">
                                <button>
                                  <i class="fas fa-file"></i> Payment
                                </button>
                              </li>
                              <li @click="chartAccounts()">
                                <button>
                                  <i class="fas fa-file"></i> Chart of Accounts
                                </button>
                              </li> 
                              <li @click="productServices()">
                                <button>
                                  <i class="fas fa-file"></i> Products &amp; Service
                                </button>
                              </li>
                              <li><button><i class="fas fa-file"></i> Projects</button></li>
                            </ul>
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <h6 class="card-subtitle mb-2 text-muted">{{customerDetail[0].bussinesname}}</h6>
                    <!-- <h5 class="mb-2">{{customerDetail[0].address}}</h5> -->
                     <h6 v-if="(customerDetail[0].billingaddress!==null)">
                      <span>{{customerDetail[0].billingaddress}}</span>&nbsp;<span v-if="customerDetail[0].bcity != null">{{customerDetail[0].bcity}}</span>,&nbsp;<span v-if="customerDetail[0].bstate != null">{{customerDetail[0].bstate}}</span>&nbsp;<span v-if="customerDetail[0].bpostcode != null">{{customerDetail[0].bpostcode}}</span>
                    </h6>
                    <h6 class="mb-2"><span style="color: #9e9e9e;">Phone: </span> 
                      <span v-if="customerDetail[0].officephone!=null">{{customerDetail[0].officephone}}</span> | 
                      <span style="color: #9e9e9e;">Cell: </span> <span v-if="customerDetail[0].mobilephone!=null">{{customerDetail[0].mobilephone}}</span>
                    </h6>
                    <h6><span v-if="customerDetail[0].email!=null">{{customerDetail[0].email}}</span></h6>
                   
                    <p v-if="customerDetail[0].notes!=null"> <b> <span style="color: #9e9e9e;">NOTES: </span> </b> {{customerDetail[0].notes}}</p>
                  </div>
                  <div class="col-md-6">
                    <div class="card">
                      <div class="card-body contenedor-total">
                        <div class="alert alert-success alert_totales_customer" role="alert">
                          TOTAL SALES: <h1> <span class="badge badge-success">$ {{ totalSales | formatMoney }}</span></h1>
                        </div>
                        <div class="alert alert-danger alert_totales_customer" role="alert">
                          OVERDUE: <h1> <span class="badge badge-danger">$ {{ overdue | formatMoney }}</span></h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 
                <div class="row tabla-transaction" >
                  <table class="table table-striped table-bordered table-hover" style="margin-bottom: 320px;">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Type</th>
                        <th scope="col">Name</th>
                      <!--   <th scope="col">Rec</th> -->
                        <th scope="col">Date</th>
                        <th scope="col" style="text-align:right">Total</th>
                        <th scope="col" style="text-align:right">Balance</th>
                        <th scope="col" style="text-align:center">Status</th>
                        <th scope="col" style="text-align:center">Email</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody v-if="tablaValid">
                      <tr v-for="i in transactionsList" >
                        <td >{{ i.nro.toString().padStart(4,"000") }}</td>
                        <td >{{ i.type }}</td>
                        <td >{{ i.name }}</td>
                        <!-- <td >
                          <span v-if="i.rec == 1" class="badge badge-success">Rec</span>
                        </td> -->
                        <td >{{ i.fecha }}</td>
                        <td style="text-align:right">$ {{ i.total | formatMoney}}</td>
                        <td style="text-align:right">$ {{ i.balance | formatMoney}}</td>
                        <td style="text-align:center">
                          <div v-if="i.type=='Payment'">
                            <span v-if="i.status == 1" class="badge badge-success">Accepted</span>
                            <span v-if="i.status == 0" class="badge badge-danger" style="background-color:#b94a48">Void</span>
                          </div>
                          <div v-else-if="i.type=='Invoice'">
                            <span v-if="i.status == 1" class="badge badge-secondary" style="background-color:#f89406">Pending</span>
                            <span v-else-if="i.status == 2" class="badge badge-primary">Partially Paid</span>
                            <span v-else-if="i.status == 3" class="badge badge-success">Paid</span>
                            <span v-else-if="i.status == 4" class="badge badge-primary" style="background-color:#e90404">Overdue</span>
                            <span v-else-if="i.status == 5" class="badge badge-danger" style="background-color:#b94a48">Void</span>
                          </div> 
                          <div v-else-if="i.type=='Estimate'">
                            <span v-if="i.status == 1" class="badge badge-secondary" style="background-color:#f89406">Pending</span>
                            <span v-if="i.status == 2" class="badge badge-success">Accepted</span>
                            <span v-if="i.status == 3" class="badge badge-primary">Rejected</span>
                            <span v-if="i.status == 4" class="badge badge-danger" style="background-color:#b94a48">Void</span>
                          </div> 
                        </td>
                        <td style="text-align:center">
                          <button  style="border:0;background: transparent; cursor:pointer; font-size:13px;" @click="actionEmail(i.id,i.nro,i.type, i.email)">
                            <span>{{i.nro_email}} </span>
                            <i class="fas fa-envelope" style="color:#f89406; font-size:18px;"></i>
                          </button>
                        </td>
                        <td style="width: 90px;">
                          <div v-if="i.type=='Invoice'">
                            <span class="cdropdown">
                              <button><span>Actions</span></button>
                              <label>
                                <input type="checkbox">
                                <ul>
                                  <li @click="actionPdfInvo(i.id)">
                                    <button><i class="fas fa-file-pdf"></i> Open PDF</button>
                                  </li>
                                  <li @click="actionPrintInvo(i.id)">
                                    <button><i class="fas fa-print"></i> ePrint</button>
                                  </li>
                                  <li @click="statement(i.id)">
                                    <button>
                                      <i class="fas fa-file-invoice-dollar"></i> Statement
                                    </button>
                                  </li>
                                  <li  @click="actionEmail(i.id,i.nro,i.type, i.email)">
                                    <button><i class="far fa-envelope"></i> Email</button>
                                  </li>
                                  <li v-if="i.status != 4" @click="actionDuplicateInvo(i.id)">
                                    <button><i class="fas fa-copy"></i> Duplicate</button>
                                  </li>
                                  <li @click="convertRecurringT(i.id)">
                                    <button>
                                      <i class="fas fa-file-alt"></i> Convert to Recurring Invoices
                                    </button>
                                  </li>
                                  <li v-if="i.idxstatus != 4"  @click="actionEditInvo(i.id)">
                                    <button>
                                      <i class="fas fa-edit"></i> Edit
                                    </button>
                                  </li>
                                  <li v-if="i.idxstatus != 4" @click="actionVoidInvo(i.id)">
                                    <button><i class="fas fa-trash-alt"></i> Void</button>
                                  </li>
                                  <li @click="MetDeleteInvoice(i.id)">
                                    <button><i class="fas fa-times"></i> Delete</button>
                                  </li>
                                </ul>
                              </label>
                            </span>
                          </div>
                          <div v-else-if="i.type=='Estimate'">
                            <span class="cdropdown">
                              <button>Actions</button>
                              <label>
                                <input type="checkbox">
                                <ul>
                                  <li @click="actionPdfEst(i.id)">
                                    <button><i class="fas fa-file-pdf"></i> Open PDF</button>
                                  </li>
                                  <li @click="actionPrintEst(i.id)">
                                    <button><i class="fas fa-print"></i> Print</button>
                                  </li>
                                  <li  @click="actionEmail(i.id,i.nro,i.type, i.email)">
                                    <button><i class="far fa-envelope"></i> Email</button>
                                  </li>
                                  <li v-if="i.status != 4" @click="actionDuplicateEst(i.id)">
                                    <button><i class="fas fa-copy"></i> Duplicate</button>
                                  </li>
                                  <li v-if="i.status == 2" @click="convertToInvoice(i.id)">
                                    <button>
                                      <i class="far fa-file-alt"></i> Convert To Invoice
                                    </button>
                                  </li>
                                  <li v-if="i.status != 4" @click="actionEditEst(i.id)">
                                    <button><i class="fas fa-edit"></i> Edit</button>
                                  </li>
                                  <li v-if="i.status != 4" @click="actionVoidEst(i.id)">
                                    <button><i class="fas fa-trash-alt"></i> Void</button>
                                  </li>
                                  <li v-if="i.status != 4" @click="MetDeleteEstimate(i.id)">
                                    <button><i class="fas fa-times"></i> Delete</button>
                                  </li>
                                </ul>
                              </label>
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else="tablaValid === false">
                      <tr>
                        <td colspan="10" class="text-center">
                          <Loader v-if="transacValid"></Loader><span v-else>No record</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="modal-setting" height="auto" @before-close="ClosedModal">
      <div class="card">
        <component :is="SettingBox" :items="DataMailTransac"></component>
      </div>
    </modal>
<notifications group="noti" position="top center">
</notifications>
</billing-customer>
</template>
<script>
import axios from 'axios'
import ClickOutside from 'vue-click-outside'
import Loader from '@/components/shared/Loader'
import BillingCustomer from '@/Layouts/Billing/BillingLayout'
import modalEmail from '@/components/billing/modalEmail'
import EventBus from '@/eventBus';
//import { setTimeout } from 'timers';
export default {
    name:'CustomerPage',
    components:{
        BillingCustomer,
        Loader,
        modalEmail,
    },
    data() {
        return {
            isLoading: false,
            ShowDefaultContentCustomer : true,
            isLoadingCustomers: false,
            MessageSuccefull : null,
            access_token : null,
            ShowMenuDropCus: false,
            registerForm : false,
            detailcontent : false,
            CustomersList: [],
            show_business : true,
            show_customer : true,
            TextSearchCustomer : '',
            customerDetail : null,
            ShowBtnDel: false,
            ShowBtncancel: false,
            ActionType:'',
            NewCustomer: {
                user_id : null,
                idcustomer : null,
                titleactionForm : '',
                firstname: null,
                lastname: null,
                businessname : null,
                active : null,
                referal : 0,
                email : null,
                officephone : null,
                mobilephone : null,
                website : null,
                billingaddress : null,
                bcity : null,
                bstate : null,
                bpostcode : null,
                address : null,
                acity : null,
                astate : null,
                apostcode : null,
                notes : null,
                error : 0,
            },
            overdue: 0,
            totalSales: 0,
            tablaValid: false,
            transactionsID: 0,
            transactionsList:[],
            customerID: null,
            transacValid: false,
            showModal: false,
            cargarmodal : '',
             DataMailTransac : {
                isLoading : false,
                id : null,
                IDitem : null, // numdoc
                email : null,
                type : null,
                EmailCheck : false,
                view: 'transac'
            },
            emailsTransac : [],
            SettingBox : '',
            paginador: 100,
            customers: [],
        }
    },
    created(){
      this.CustomerList();
    },
    mounted(){
    this.getCustomers();
    },
    directives: {
    ClickOutside
  },
    methods: {
      abrirCanalEventBus(){
          let vm = this;
          EventBus.$on(this.DataMailTransac.view+'-email',(item)=>{this.emailsTransac =item; 
            vm.sendMailTransac(item);
          });
        },
      ClosedModal(){
            this.cargarmodal =''
        },
      getTransactions(){
     
          this.tablaValid=false;
          window.billing.post('customer/'+ this.customerID, 
            {
              user_id: window.localuserdata, 
              trans: this.transactionsID,
              pag: this.paginador
            })
          .then((response) => {              
              let transac =response.data.trasaction;
              this.transactionsList=transac;
              if(this.transactionsList.length > 0){
                this.tablaValid= true;
                this.transacValid=true;
                for(let i in transac){
                  if(transac[i].type=='Invocie'){
                    let f = new Date(transac[i].fv);
                    let fa = new Date();
                    if(fa > f){transac[i].status = 4}
                  }
                }
              }
              else{this.tablaValid=false;this.transacValid=false;}
            })
          .catch((error) => console.log(error));
      },
        hide () {
        this.ShowMenuDropCus = false
        },
         filterCustomerxxx(list, value){
            value = value.charAt(0).toUpperCase() + value.slice(1);
            return list.filter(function(item){
            return item.firstname.indexOf(value) > -1 || item.bussinesname.indexOf(value) > -1
            
            });
        },
        check: function(e) {
      
        
        if(this.show_business){
        
          window.billing.post('customer/setting',{
                show_business: 'true',
                user_id: window.localuserdata
           }).then((response) => {
                     this.ShowMenuDropCus = false;
                     this.getCustomers();

                }).catch((error) => console.log(error,this.isLoading = false));
        }else{
         
          window.billing.post('customer/setting',{
                show_business: 'false',
                user_id: window.localuserdata
           }).then((response) => {
                     this.ShowMenuDropCus = false;
                     this.getCustomers();

                }).catch((error) => console.log(error,this.isLoading = false));
          }
          
        },
        checkcus: function(e) {
     
        
        if(this.show_customer){
        
          window.billing.post('customer/setting',{
                show_customer_inactives: 'true',
                user_id: window.localuserdata
           }).then((response) => {
                     this.ShowMenuDropCus = false;
                     this.getCustomers();

                }).catch((error) => console.log(error,this.isLoading = false));
        }else{
         
          window.billing.post('customer/setting',{
                show_customer_inactives: 'false',
                user_id: window.localuserdata
           }).then((response) => {
                     this.ShowMenuDropCus = false;
                     this.getCustomers();

                }).catch((error) => console.log(error,this.isLoading = false));
          }
          
        },

        getCustomers ()  {
              var self = this;
              this.isLoadingCustomers = true;
            window.billing.get('customersc/'+ window.localuserdata)
                .then((response) => {
                    console.log(response.data.result)         
                    self.CustomersList = response.data.result;
                    //console.log('lista de customer', response.data.result)
                    self.show_business = response.data.show_business;
                    self.show_customer = response.data.show_customer;

					self.isLoadingCustomers = false;
                }).catch((error) => console.log(error));
        },
        detailCustomer(idc){
          this.customerID = idc;
          this.isLoading = true;
          this.ShowDefaultContentCustomer = false;
          this.detailcontent = true;
          this.registerForm = false;
          window.billing.post('customer/'+idc, {user_id: window.localuserdata, trans: 0, pag: this.paginador})
          .then((response) => {
              this.isLoading = false;
              this.customerDetail = response.data.result;
              this.detailcontent = true;
              this.overdue= response.data.result[0].balance;
              this.totalSales= response.data.result[0].totalSales;
              let transac =response.data.trasaction;
              this.transactionsList=transac;
              if(this.transactionsList.length > 0){
                this.tablaValid= true;
                this.transacValid=true;
                for(let i in transac){
                  if(transac[i].type=="Invoice"){
                    let f = new Date(transac[i].fv);
                    let fa = new Date();
                    if(fa > f && transac[i].status != 3 && transac[i].status != 5){transac[i].status = 4}
                  }
                }
              }
              else{this.tablaValid=false;this.transacValid=false;}
            })
          .catch((error) => console.log(error));
        },
        ShowMenuDropPCus(){
            
            this.ShowMenuDropCus = true;

        },
        MetNewCustomerAdd(){
            
            this.ShowDefaultContentCustomer = false;
            this.isLoading = true;
            if(this.ActionType == 'new'){
               window.billing.post('customer/add',{
                user_id : window.localuserdata,
                firstname: this.NewCustomer.firstname,
                lastname: this.NewCustomer.lastname,
                businessname: this.NewCustomer.businessname,
                active: this.NewCustomer.active,
                referal: this.NewCustomer.referal,
                email: this.NewCustomer.email,
                officephone: this.NewCustomer.officephone,
                mobilephone: this.NewCustomer.mobilephone,
                website: this.NewCustomer.website,
                billingaddress: this.NewCustomer.billingaddress,
                bcity: this.NewCustomer.bcity,
                bstate: this.NewCustomer.bstate,
                bpostcode: this.NewCustomer.bpostcode,
                address: this.NewCustomer.address,
                acity: this.NewCustomer.acity,
                astate: this.NewCustomer.astate,
                apostcode: this.NewCustomer.apostcode,
                notes: this.NewCustomer.notes
              }).then((response) => {
                 this.MessageSuccefull = response.data;
                 this.isLoading = false;
                 this.getCustomers();
                 /*this.$swal.fire({
                    type: 'success',
                    title: 'Successful registration',
                    showConfirmButton: false,
                    timer: 2000
                    })*/
                 this.$notify({
                    group: 'noti',
                    title: 'Success',
                    type: 'success',
                    text: 'New customer added'
                  });
                  //this.$router.go(this.$router.currentRoute)
                 this.MetClearFormCustomer();
                this.detailCustomer(response.data.customer.id);
                }).catch((error) => console.log(error,this.isLoading = false));
             }

            if(this.ActionType == 'update'){
                let idc= this.NewCustomer.idcustomer;
                window.billing.post('customer/edit/' + this.NewCustomer.idcustomer,{
                user_id : this.NewCustomer.user_id,
                idcustomer: this.NewCustomer.idcustomer,
                firstname: this.NewCustomer.firstname,
                lastname: this.NewCustomer.lastname,
                businessname: this.NewCustomer.businessname,
                active: this.NewCustomer.active,
                referal: this.NewCustomer.referal,
                email: this.NewCustomer.email,
                officephone: this.NewCustomer.officephone,
                mobilephone: this.NewCustomer.mobilephone,
                website: this.NewCustomer.website,
                billingaddress: this.NewCustomer.billingaddress,
                bcity: this.NewCustomer.bcity,
                bstate: this.NewCustomer.bstate,
                bpostcode: this.NewCustomer.bpostcode,
                address: this.NewCustomer.address,
                acity: this.NewCustomer.acity,
                astate: this.NewCustomer.astate,
                apostcode: this.NewCustomer.apostcode,
                notes: this.NewCustomer.notes
              }).then((response) => {
                     console.log(response.data);
                     this.MessageSuccefull = response.data;
                 this.isLoading = false;
                 this.getCustomers();
                 /*this.$swal.fire({
                    type: 'success',
                    title: 'Updated Ok',
                    showConfirmButton: false,
                    timer: 2000
                    })*/
                    
                 this.$notify({
                    group: 'noti',
                    title: 'Success',
                    type: 'success',
                    text: 'Customer updated successfully.'
                  });
                  //this.$router.go(this.$router.currentRoute)
                 this.MetClearFormCustomer();
                this.detailCustomer(idc);
                }).catch((error) => console.log(error,this.isLoading = false));

               
            }

        },
        MetEditCustomers(){
            this.ActionType = 'update'
            this.NewCustomer = {
                        titleactionForm : 'Edit',
                        user_id : window.localuserdata,
                        idcustomer : this.customerDetail[0].id,
                        firstname : this.customerDetail[0].firstname,
                        lastname : this.customerDetail[0].lastname,
                        email : this.customerDetail[0].email,
                        officephone : this.customerDetail[0].officephone,
                        mobilephone : this.customerDetail[0].mobilephone,
                        website : this.customerDetail[0].website,
                        billingaddress : this.customerDetail[0].billingaddress,
                        bcity : this.customerDetail[0].bcity,
                        businessname : this.customerDetail[0].bussinesname,
                        address : this.customerDetail[0].address,
                        bstate : this.customerDetail[0].bstate,
                        bpostcode : this.customerDetail[0].bpostcode,
                        acity : this.customerDetail[0].acity,
                        astate : this.customerDetail[0].astate,
                        apostcode : this.customerDetail[0].apostcode,
                        active : this.customerDetail[0].active,
                        referal : this.customerDetail[0].referal,
                        notes : this.customerDetail[0].notes,
                        error : 0
                    }
            this.ShowDefaultContentCustomer = false;
            this.detailcontent = false;
            this.registerForm = true;
            this.ShowBtnDel= true;
            this.ShowBtncancel= true;
        },
        MetDeleteCustomer(id){
         console.log(id);
         window.billing.delete('customer/'+ id)
                .then((response) => {
                   
                     if(response.data.success){
                       console.log('deeted');
                       this.getCustomers();
                       this.$notify({
                        group: 'noti',
                        title: 'Deleted',
                        type: 'success',
                        text: 'Deleted successfull.'
                      });
        
                     }else{
                       this.$notify({
                        group: 'noti',
                        title: 'Error',
                        type: 'error',
                        text: 'This customer have attached documents and can not be deleted.'
                      });
        
                     }
                   this.MetCancelFormC();
                     
                }).catch(function (error) {
              console.log(error);
            });
        },
        MetCancelFormC(){
         this.ShowDefaultContentCustomer = true;
         this.registerForm = false;
        },
        MetCancelFormC2(idc){
          if(window.innerWidth<=767){document.getElementById('s-f-r').style.display='block';}
          //console.log('customer ='+ idc);
         this.ShowDefaultContentCustomer = false;
         this.registerForm = false;
         this.detailCustomer(idc);
        },
        MetClearFormCustomer() {
          this.MessageSuccefull = null;
             this.NewCustomer = {
                        idcustomer : '',
                        firstname : '',
                        lastname : '',
                        businessname : '',
                        active : '1',
                        referal : '',
                        email : '',
                        officephone : '',
                        mobilephone : '',
                        website : '',
                        billingaddress : '',
                        bcity : '',
                        bstate : '',
                        bpostcode : '',
                        address : '',
                        acity : '',
                        astate : '',
                        apostcode : '',
                        notes  : '',
                        error  : 0
                     }
        },
        showformregister(){
          this.MetClearFormCustomer();
          this.ActionType = 'new';
          this.NewCustomer.titleactionForm = 'New';
          this.ShowDefaultContentCustomer = false;
          this.detailcontent = false;
          this.registerForm = true;
          this.ShowBtnDel= false;
          this.ShowBtncancel= false;
          if(window.innerWidth<=767){document.getElementById('s-f-r').style.display='none';}


      },
      EmitMethodStatus(){
          this.ShowDefaultContentCustomer = true;
      },
      actionEmail(id, nro, type, email){
          type = type.toLowerCase();
          this.DataMailTransac.idinv = id;
          this.DataMailTransac.IDitem = nro;
          this.DataMailTransac.email = email;
          this.DataMailTransac.type = type;
          this.DataMailTransac.view = type;
          this.SettingBox ='modalEmail';
          this.$modal.show('modal-setting');
          this.abrirCanalEventBus();

      },
      actionPrintInvo(idinv){
        console.log('actionPrintInvo', idinv);
        this.isLoading = true;
        window.billing.post('eprintinvo/' + idinv,{
            user_id : window.localuserdata,
            'eprint': 1
          }).then((response) => {
            console.log(response.data);
            this.isLoading = false;
            if(response.data.status){
              this.$notify({
                group: 'noti',
                title: 'Send!',
                type: 'success',
                text: 'Send Successful'
              });
            }else{
              this.$notify({
                group: 'noti',
                title: 'Send Mail!',
                type: 'error',
                text: 'Send error',
              });
            }
          }).catch((error) => {
            console.log(error);
            this.isLoading = false;
            this.$notify({
                group: 'noti',
                title: 'Send!',
                type: 'error',
                text: 'Send Error'
              });
          });
      },
      actionPdfInvo(id){
        window.open(window.urlbase + "api/v2/invoice/pdf/" + id+'/'+window.localAccountID+'/'+localStorage.getItem('oauth_m') , "_blank");
      },
      actionEditInvo(id){
        this.$router.push({name:'InvoiceDet', params:{idinv:id, edit: 'edit'}});
      },
      MetDeleteInvoice(idinv){
        this.isLoading = true
        
        this.$swal({
          title: "Delete this Invoice?",
          text: "Are you sure?",
          type: "warn ",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.put('invoice/delete/' + idinv,{
                    user_id : window.localuserdata
            }).then((response) => {
               
              console.log(response.data);
              this.isLoading = false;
              if(response.data.status){
                this.getTransactions();
                this.$notify({
                        group: 'noti',
                        title: 'Success',
                        type: 'success',
                        text: 'Deleted Invoice Successful.'
                      });
              }
            }).catch((error) => console.log(error,this.isLoading = false));
          }
        });
        this.isLoading = false   
      },
      actionVoidInvo(idinv){
        this.isLoading = true 
        this.$swal({
          title: "Void this Invoice?",
          text: "You will not be able to recover it",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Void it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.put('invoice/void/' + idinv,{
              user_id : window.localuserdata
            }).then((response) => {
              this.isLoading = false;
              if(response.data.status)
              {
                this.getTransactions();
                this.$notify({
                        group: 'noti',
                        title: 'Void!',
                        type: 'success',
                        text: 'Void Invoice Successful.'
                      });
              }
            }).catch((error) => console.log(error,this.isLoading = false));
          }
        });
        this.isLoading = false 
      },
      actionDuplicateInvo(id){
        this.$router.push('invoice/'+ id + '/duplicate');
      },
      actionPdfEst(id){
          window.open(window.urlbase+"api/v2/estimate/pdf/" + id , "_blank");
      },
      actionEditEst(id){
          this.$router.push({name:'EstimatesDet', params:{idest:id}});
      },
      actionPrintEst(idest){        
          this.isLoading = true;
          window.billing.post('eprintest/' + idest,{
            user_id : window.localuserdata,
            eprint: 1
          }).then((response) => {
            console.log(response.data);
            this.isLoading = false;
            if(response.data.status){
              this.$notify({
                group: 'noti',
                title: 'Send Mail!',
                type: 'success',
                text: 'Send Successful',
              });
            }else{
              this.$notify({
                group: 'noti',
                title: 'Send Mail!',
                type: 'error',
                text: 'Send error',
              });
            }
          }).catch((error) => {
            console.log(error);
            this.isLoading = false;
            this.$notify({
              group: 'noti',
              title: 'Send Mail!',
              type: 'error',
              text: 'Send error',
            });
          }); 
      },
      MetDeleteEstimate(idest){
        this.isLoading = true
        this.$swal({
          title: "Delete this Estimate?",
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.put('estimate/delete/' + idest,{
              user_id : window.localuserdata
            }).then((response) => {
              this.isLoading = false;
              if(response.data.status)
              {
                this.getTransactions();
                this.$notify({
                        group: 'noti',
                        title: 'Deleted!',
                        type: 'success',
                        text: 'Deleted Estimate Successful.'
                      });
              }
            }).catch((error) => console.log(error,this.isLoading = false));
          }
        });
        this.isLoading = false;
      },
      actionVoidEst(idest){
        this.isLoading = true;
        this.$swal({
          title: "Void this Estimate?",
          text: "You will not be able to recover it",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Void it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.put('estimate/void/' + idest,{
              user_id : window.localuserdata
            }).then((response) => {
              this.isLoading = false;
              if(response.data.status)
              {
                this.getTransactions();
                 this.$notify({
                        group: 'noti',
                        title: 'Void!',
                        type: 'success',
                        text: 'Void Estimate Successful.'
                      });
              }
            }).catch((error) => console.log(error,this.isLoading = false));
          }
        });
        this.isLoading = false 
      },
      actionDuplicateEst(id){
        this.$router.push('estimate/'+ id + '/duplicate');
      },
      convertRecurringT(id){
        this.$router.push({name:'InvoiceRecConvert', params:{idinv:id, convert: 'convert'}});
     },
      invoiceNewtransac(idc){
        this.$router.push({name:'InvoiceNewTransac', params:{idc:idc, transac: 'transac'}});
      },
      estimateNewtransac(idc){
        this.$router.push({name:'EstimatesNewTransac', params:{idc:idc, transac: 'transac'}});
      },
      paymentsNewtransac(idc){
        this.$router.push({name:'PaymentsReceivedNewTransac', params:{idc:idc, transac: 'transac'}});
      },
      recurringNewtransac(idc){
        this.$router.push({name:'InvoiceRecTransac', params:{idc:idc, transac: 'transac'}});
      },
      chartAccounts(){
        this.$router.push({ name: 'ChartAccounts'});
      },
      productServices(){
        this.$router.push({ name: 'ProductServices'});
      },
      statement(id){
        this.$router.push('statement/'+ id + '');
      },
      convertToInvoice(id){
        this.$router.push({name:'EstimatesConvertInvoice', params:{idest:id, convert: 'convert'}});
      },   
      sendMailTransac(item){      
        if(item.DataItem.send==1){
          item.DataItem.send=0;
          this.$modal.hide('modal-setting');
          this.SettingBox = '';
          this.getTransactions();
          this.$notify({
            group: 'noti',
            title: 'Success',
            type: 'success',
            text: 'Send Mail!'
          });
          EventBus.$off(item.DataItem.view+'-email');
        }
      },
      ExportCustomer(){
        this.isLoading = true;
        console.log('export');
        window.billing.get('report/export/customers/' + window.localuserdata)
        .then((response) => {
          this.isLoading = false;
          console.log(response.data.result);
          window.open(window.urlbase+'files/'+response.data.result , "_blank");
        }).catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
       },
       CustomerList(){
        this.isLoading = true;
        window.billing.get('report/customers/' + window.localuserdata)
        .then((response) => {
          console.log(response.data)
          this.isLoading = false;
          if(response.data.status){
            this.customers = response.data.result;
          }
        }).catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
       },
    },
    beforeMount(){
        
    },

    computed:
    {
      Totalactivos:  function () {
            return this.customers.filter(r => r.active === 1 && r.activorestore === 0);
        },
      inactivos:  function () {
            return this.customers.filter(r => r.active === 0 && r.activorestore === 0);
        },
      filteredCustomer: function () {
            var self = this;
            return this.CustomersList.filter(function (item) {
                return item.firstname && item.firstname.toLowerCase().indexOf(self.TextSearchCustomer.toLowerCase()) >= 0
                || item.bussinesname && item.bussinesname.toLowerCase().indexOf(self.TextSearchCustomer.toLowerCase()) >= 0
                || item.lastname && item.lastname.toLowerCase().indexOf(self.TextSearchCustomer.toLowerCase()) >= 0;
            });
        }
    },
    watch: {
      NewCustomer: {
        deep: true,
        handler: (e) => {
          //debugger;
          for(var i in e){
            if(i!='notes' && i!='error'){
              if(e[i]!=null && e[i].length > 0){
                if(e[i].indexOf(',') > -1){
                  //console.log(i, e[i]);
                  e['error']=parseInt(e['error'])+1;
                  e[i] = e[i].replace(",", "");
                  console.log(e);
                }
              }
            }  
          }          
        }
      },
      "NewCustomer.error": function(e) {
        if(e> 0){
          this.$notify({
            group: 'noti',
            title: 'Error',
            type: 'error',
            text: 'The symbol coma “,” is not allowed.'
          });
          return e=0;
        }
      },
    }
   
};
</script>
<style scope="sass">
.vue-notification-group{
  position:absolute!important;
}
.eboton i{font-size: 12px;}
.eboton{
  padding: 5px 10px;
  font-size: 14px;
  margin-left:10px;
  color: #fff;
  background-color: #137eff !important;
  border-color: #137eff !important;
}
#btnGroupDrop1{
  height: 26px;
  padding-top: 0px;
}
button.btn.btn-success.btn-new {
  padding: 0px ;
  width: 26px;
  height: 26px;
}
.Btncancel{background-color: #fff; border-color:#000;}
.Btncancel,.BtnSave,.BtnDel{border-radius: 2px;}
.Btncancel,.BtnSave,.BtnDel{
  margin-left: 5px;
  padding: 5px 10px;
  font-size: 14px;
}
.contenedor-total{
  padding: 0rem ;
}
.alert_totales_customer{    
  display: inline-block;
  padding: 0.2rem .5rem;
  width: 50%;
  text-align: center;
}
.alert_totales_customer h1 span{    
  font-size: 20px;
}
.tabla-transaction {width: 100%}
@media(max-width: 1190px){
  .tabla-transaction {max-width: 800px; overflow-x: scroll;}
  .tabla-transaction table {min-width: 800px;}
  .alert_totales_customer{ 
    display: inline-block; 
    width: 50%; 
    text-align: right;
  }
  .alert_totales_customer h1 span{    
    font-size: 14px;
  }
}
@media(max-width: 991px){
  .alert_totales_customer{ 
    display: inline-block; 
    width: 100%; 
    text-align: right;
  }
  .alert_totales_customer h1 span{    
    font-size: 18px;
  }
}
@media(max-width: 767px){
  .list-group.list-group-flush{
    height: 240px;
  }
  .filteredCustomer{padding: 12px 20px !important;}
}
.balance{color:#FF0000;}
.btn-transaction{
  color: #fff !important;
  background-color: #137eff !important;
  border-color: #137eff !important;
  border-radius: 2px !important;
}
.row.tabla-transaction td { font-size: 12px;}
.msj-no-customer{
  position: relative;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 30px;
}
#content-customer {
  margin-top: 5px;
  margin-left: -5px;
}
.right-contenendor{
  padding: 0px;
  border-left: 1px solid #c9cbcc;
  background: #fff;
}
.d-flex0 {
    flex-wrap: wrap !important;
    justify-content: space-between !important;
  }
@media(min-width: 767px){
.d-flex0 .c-ol{
  width:48%;
}
}
@media(max-width: 767px){
.d-flex0 .c-ol{
  width:100%;
}
.btn.btn-info.btn-sm.eboton{
    width: 100%;
    margin: 0px;
    margin-bottom: 10px;
}
select.form-control{
    padding: 0px;
    width: 100%;
    margin-bottom: 10px;
}
span.cdropdown{
      width: 100%;
}
span.cdropdown .btn.btn-transaction{
      width: 100%;
}
}
</style>
